module.exports = __webpack_public_path__ + "static/segment-image-14d6df611c7f72e708db8d0674189c89.png";